<template>
<div  class="flex items-center" :isDark="isDark" :toggleDark="toggleDark">
  <div class=" flex items-center btn  justify-center">
    <div class=" w-4  h-5 flex justify-center items-center" @click="toggleDark()"   :class="{ 'bg-white shadow h-6 w-6 rounded-full' : !isDark}">
    </div>
    <div class=" w-4  h-5  flex justify-center items-center" @click="toggleDark()"   :class="{ 'bgBlue shadow h-6 w-6 rounded-full' : isDark}" >
    </div>
  </div>
</div>



</template>



<script setup>
import { useDark, useToggle } from "@vueuse/core"
const isDark = useDark()
const toggleDark = useToggle(isDark)

// console.log(isDark.value);

</script>

<style scoped>

/* .blackbg{
background: white;
width:25px;
height: 25px;
border-radius: 50%;
} */

.bgBlue{
  background: #1e90ff;
  /* width: 25px;
  height: 25px;
  border-radius: 50%;
  z-index: 100; */
}

.btn{
  border: grey;
  background: rgb(246, 246, 246);
  border-radius: 25px;
  height: 19px;
  width: 100%;
}
</style>
